import { render, staticRenderFns } from "./FacturerBadge.vue?vue&type=template&id=6868b54e"
import script from "./FacturerBadge.vue?vue&type=script&lang=js"
export * from "./FacturerBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports